export function getForgeFileExtension(file) {
  return `${file?.ext || ''}`.replace('.', '').toLowerCase()
}

export function isForgeItem(file, supportedExtensions = []) {
  if (!file || file.type === 'folder') return false

  const extension = getForgeFileExtension(file)
  return supportedExtensions.some(supportedExtension => (
    `${supportedExtension}`.replace('.', '').toLowerCase() === extension
  ))
}

export function isForgeTranslated(file) {
  return !!file?.forge_file?.translated
}

export function isForgeProcessing(file) {
  return !!file?.forge_file?.processing
}

export function hasForgeFile(file) {
  return !!file?.forge_file
}
